<template>
	<div>
		<div v-if="Data.length > 0">
			<div class="course-box">
				<router-link tag="div" class="flex-start course-card cursor" :class="{'card-padding':isStatus == 1}" 
				:to="{path:'/feedDetail?id='+item.id+'&code='+code}"
				 v-for="(item,index) in Data" :key="index">
					<img :src="item.main_drawing_pc" alt="">
					<div class="course-content">
						<div class="course-name fsm2 line2">{{item.title}} </div>
						<div class="course-pro fsmain">
							<div class="course-join flex-space">
								{{item.created_at}}
							</div>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<div class="mt-noData" v-else>
			<noData></noData>
		</div>
	</div>
</template>

<script>
	import noData from '@/components/noData/index.vue'
	export default{
		components: {
			noData
		},
		props: {
			code:{
				type:String,
				default:''
			},
			Data:{
				type:Array,
				default:()=>{ return [] }
			},
			isStatus:{
				type:Number,
				default:0
			},
		},
		data() {
			return {
			}
		}
	}
</script>

<style lang="less" scoped>
	.course-box{
		display: flex;
		flex-wrap: wrap;
		.course-card{
			background: #FFFFFF;
			box-shadow: 0 0 12px rgba(187,178,178,0.25);
			border-radius: 8px;
			padding: 20px;
			width: 590px;
			margin-bottom: 20px;
			position: relative;
			&:nth-of-type(2n){
				margin-left: 20px;
			}
			.status{
				width: 80px;
				height: 30px;
				background: #E5E5E5;
				border-radius: 8px 15px 15px 0px;
				position: absolute;
				top: 0;
				left: 0;
				text-align: center;
				line-height: 30px;
				color: #999999;
			}
			img{
				width: 218px;
				height: 136px;
				border-radius: 5px;
				margin-right: 20px;
			}
			.course-name{
				margin-bottom: 15px;
				line-height: 1.2;
			}
			.course-pro{
				color: #666;
				.course-join{
					position: absolute;
					bottom: 30px;
					width: 310px;
					.link{
						width: 90px;
						height: 34px;
						background: linear-gradient(87deg, #FD9A3D, #F3702A);
						border-radius: 17px;
						text-align: center;
						line-height: 34px;
						color: #fff;
					}
				}
			}
		}
		.card-padding{
			padding: 50px 20px 20px;
		}
	}
	.dataMes{
		width: 300px;
		margin: 0 auto;
		.data{
			border: 1px solid #eee;
			padding: 15px 15px;
			border-radius: 5px;
		}
		img{
			width: 218px;
			height: 136px;
			border-radius: 5px;
			display: block;
			margin: 0 auto 10px;
		}
		.course-name{
			color: #333;
		}
		.course-format{
			color: #666;
			margin-top: 5px;
		}
		.score{
			color: #666666;
			margin: 10px 0;
		}
		.pay{
			b{
				color: #F3702A;
			}
		}
		.btn{
			width: 150px;
			height: 46px;
			background: #F26F2A;
			border-radius: 10px;
			line-height: 46px;
			text-align: center;
			color: #fff;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/Course/xueyuan.vue